if (!customElements.get("el-timeline-stats")) {
  customElements.define(
    "el-timeline-stats",
    class ElTimelineStats extends HTMLElement {
      constructor() {
        super();

        this.hasAnimatedStats = false;
      }

      connectedCallback() {
        if (this.dataset.ready === "true") return;
        this.dataset.ready = "true";

        this.tabs = Array.from(this.querySelectorAll("[data-timeline-tab]"));
        this.swiperHost = this.querySelector(".el-timeline-stats__swiper-host");

        this.setupTimeline();
        this.setupStatsAnimation();
      }

      setupTimeline() {
        if (!this.swiperHost || !this.tabs.length) return;

        const waitForSwiper = () => {
          const swiper = this.swiperHost.mainSwiper;

          if (!swiper) {
            requestAnimationFrame(waitForSwiper);
            return;
          }

          this.swiper = swiper;

          this.tabs.forEach((tab) => {
            tab.addEventListener("click", () => {
              const index = Number(tab.dataset.timelineTab || 0);
              this.swiper.slideTo(index);
              this.updateActiveTab(index);
            });
          });

          this.swiper.on("slideChange", () => {
            this.updateActiveTab(
              this.swiper.realIndex || this.swiper.activeIndex || 0,
            );
          });

          this.updateActiveTab(
            this.swiper.realIndex || this.swiper.activeIndex || 0,
          );
        };

        waitForSwiper();
      }

      updateActiveTab(activeIndex) {
        this.tabs.forEach((tab) => {
          const tabIndex = Number(tab.dataset.timelineTab || 0);
          tab.classList.toggle("is-active", tabIndex === activeIndex);
        });
      }

      setupStatsAnimation() {
        const statCards = Array.from(this.querySelectorAll("[data-stat-card]"));

        if (!statCards.length) return;

        const runAnimation = () => {
          if (this.hasAnimatedStats) return;

          this.hasAnimatedStats = true;

          statCards.forEach((card) => {
            const numberEl = card.querySelector("[data-stat-number]");
            const target = Number(card.dataset.statPercent || 0);

            if (!numberEl) return;

            const safeTarget = Math.max(0, Math.min(target, 100));
            const progressScale = safeTarget / 100;

            card.style.setProperty("--stat-progress", progressScale);
            card.classList.add("is-animated");

            this.animateNumber(numberEl, safeTarget);
          });
        };

        if (!("IntersectionObserver" in window)) {
          runAnimation();
          return;
        }

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                runAnimation();
                observer.disconnect();
              }
            });
          },
          {
            threshold: 0.35,
          },
        );

        observer.observe(this);
      }

      animateNumber(element, target) {
        const duration = 1200;
        const startTime = performance.now();

        const tick = (currentTime) => {
          const elapsed = currentTime - startTime;
          const progress = Math.min(elapsed / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          const value = Math.round(target * eased);

          element.textContent = `${value}%`;

          if (progress < 1) {
            requestAnimationFrame(tick);
          } else {
            element.textContent = `${target}%`;
          }
        };

        requestAnimationFrame(tick);
      }
    },
  );
}
